const defaultLabels = {
  active: "Activa",
  paused: "Pausada",
  sent: "Enviada",
  delivered: "Entregada",
  failed: "Fallida",
  skipped: "Omitida",
  queued: "En cola",
  preparing: "Preparando",
  extracting_text: "Leyendo documentos",
  extracting_fields: "Extrayendo datos",
  awaiting_review: "Para revisar",
  generating_output: "Generando archivo",
  completed: "Completado",
};

export function StatusBadge({
  status,
  label = defaultLabels[status] || status,
  className = "",
}) {
  return (
    <span
      className={`suite-status-badge suite-status-badge--${status} ${className}`.trim()}
    >
      <span className="suite-status-dot" />
      {label}
    </span>
  );
}
